// TBD - Only placeholder until we start working on this module, paths might change
import { RouteNames } from '@/types/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'datasets',
    name: RouteNames.DATASET_HOME,
    redirect: { name: RouteNames.DATASETS },
    children: [
      {
        name: RouteNames.DATASETS,
        path: '',
        components: {
          default: () => import('./views/ListDatasets.vue'),
        },
      },
      {
        path: ':datasetId',
        name: RouteNames.DATASET,
        components: {
          default: () => import('./views/ViewDataset.vue'),
        },
      },
    ],
  },
  {
    path: 'benchmarks',
    name: RouteNames.BENCHMARK_HOME,
    redirect: { name: RouteNames.BENCHMARKS },
    children: [
      {
        path: '',
        name: RouteNames.BENCHMARKS,
        components: {
          default: () => import('./views/ListBenchmarks.vue'),
        },
      },
      {
        path: ':benchmarkId',
        name: RouteNames.BENCHMARK,
        components: {
          default: () => import('./views/ViewBenchmark.vue'),
        },
      },
      {
        path: ':benchmarkId/executions/:executionId',
        name: RouteNames.LINEAGES,
        components: {
          default: () => import('./views/ViewBenchmarkExecution.vue'),
        },
      },
    ],
  },
];
export default routes;
